<template>
    <div class="results">
        <h1>Find Your Perfect UV Protection</h1>
        <p>Your Results</p>

        <div class="products">
            <div class="the-product main-product">
                <product-view :upc="upc" />
            </div>

            <p class="results__we-also-recommend">We Also Recommend</p>
            <div class="products__we-also-recommend">
                <product-view v-for="([upc, name], i) in recommendations" minimal :upc="upc" :key="i" />
            </div>

            <div class="results-nav">
                <button value="save my results" @click="saveConsultation">Save My Results</button>

                <button value="save my recommendations for later" @click="addAllToBag(true)">save my recommendations for later</button>

                <button value="Start Over" @click="clearConsultation">Start Over</button>
            </div>

            <div class="lightbox loginmessage continuemessage" v-if="showPopup">
                <div class="message loginprompt">
                    <a class="noload close" @click="showPopup = false">X</a>
                    <p v-if="!iswishlist">Your regimen has been successfully saved and will be displayed when you return to the Suncare Finder</p>
                    <p v-if="iswishlist">Your regimen products have successfully been saved for later.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Product from './product.vue'
import { decodeUriSegment } from './utiliites'
import { analytics, user, shopping } from 'shiseido-apis'
import logic from './data/logic.json'

export default {
    components: { 'product-view': Product },
    data() {
        return {
            upc: null,
            img: null,
            showPopup: false,
            iswishlist: false,
            product_name: '',
        }
    },
    created() {
        const { product, protect, formula, lifestyle } = this.getDecodedParams()

        const [result,...also_recommended] = logic.logic[product][protect][formula][lifestyle]
        const [upc, name] = result

        this.upc = upc
        this.product_name = name
        this.recommendations = also_recommended
    },
    methods: {
        getDecodedParams() {
            const decoded_params = this.$route.params
            Object.keys(decoded_params).forEach((k) => {
                decoded_params[k] = decodeUriSegment(decoded_params[k])
            })

            return decoded_params
        },
        saveConsultation() {
            this.$cookie.set('suncarefinder', this.$route.path, 365)
            this.showPopup = true
            this.iswishlist = false

            analytics.registerClick({
                toolname: 'Suncare Finder',
                element: 'Save Consultation',
                question: 'Results',
                answers: [this.$route.path],
            })
        },
        clearConsultation() {
            this.$cookie.delete('suncarefinder')

            analytics.registerClick({
                element: 'Start Over',
                toolname: 'Suncare Finder',
                question: 'Results',
                answers: [],
            })

            this.$emit('next', '/')
        },
        emailConsultation() {
            analytics.registerClick({
                toolname: 'Suncare Finder',
                element: 'Email Consultation',
                question: 'Results',
                answers: [],
            })
        },
        addAllToBag(wishlist) {
            const upcs = [
                '0768614104681',
                '0730852125599',
                '0730852104785',
                '0729238125582',
            ].concat(this.upc)

            if (wishlist) {
                if (user.loggedIn()) {
                    this.showPopup = true
                    this.iswishlist = true
                } else {
                    history.pushState({}, null, `${ window.location.origin }?hashpath=${ this.$route.path }/#${ this.$route.path }`)
                }

                shopping.addToWishlist(upcs)
            } else {
                shopping.addToCart(upcs)
            }

            analytics.registerClick({
                element: 'Save My Recommendations For Later',
                toolname: 'Suncare Finder',
                question: 'Results',
                answers: [upcs],
            })
        },
    },
}
</script>


// WEBPACK FOOTER //
// development/js/results.vue